import { render, staticRenderFns } from "./GerenciarAplicacoes.vue?vue&type=template&id=9f947810&scoped=true"
import script from "./GerenciarAplicacoes.vue?vue&type=script&lang=js"
export * from "./GerenciarAplicacoes.vue?vue&type=script&lang=js"
import style0 from "./GerenciarAplicacoes.vue?vue&type=style&index=0&id=9f947810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f947810",
  null
  
)

export default component.exports